import { useState } from 'react'
import {
  ActionIcon, Badge, Button, Group, Stack, Table, Title, Tooltip,
} from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useQuery } from '@tanstack/react-query'
import { IconEdit, IconPlus } from '@tabler/icons-react'
import type { Area } from '@serkat/shared'
import { api } from '../../api/cliente'
import { useSesion } from '../auth/useSesion'
import { ModalArea } from './componentes/ModalArea'

export function AreasPagina() {
  const { usuario } = useSesion()
  const [editando, setEditando] = useState<Area | undefined>()
  const [abierto, modal] = useDisclosure(false)

  const { data: areas } = useQuery({
    queryKey: ['areas'],
    queryFn: () => api.get<Area[]>('/areas?soloActivas=false'),
  })

  // Procura da de alta porque es quien topa con el área faltante al emitir.
  const puedeEditar = usuario?.rol === 'PROCURA' || usuario?.rol === 'ADMIN'

  function abrir(a?: Area) {
    setEditando(a)
    modal.open()
  }

  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={2}>Áreas solicitantes</Title>
        {puedeEditar && (
          <Button leftSection={<IconPlus size={16} />} onClick={() => abrir()}>
            Nueva área
          </Button>
        )}
      </Group>

      <Table.ScrollContainer minWidth={560}>
        <Table withTableBorder highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Nombre</Table.Th>
              <Table.Th w={140}>Código</Table.Th>
              <Table.Th w={110}>Estado</Table.Th>
              <Table.Th w={60} />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {(areas ?? []).map((a) => (
              <Table.Tr key={a.id}>
                <Table.Td>{a.nombre}</Table.Td>
                <Table.Td ff="monospace">{a.codigo}</Table.Td>
                <Table.Td>
                  <Badge color={a.activo ? 'teal' : 'gray'} variant="light" size="sm">
                    {a.activo ? 'Activa' : 'Inactiva'}
                  </Badge>
                </Table.Td>
                <Table.Td>
                  {puedeEditar && (
                    <Tooltip label="Editar">
                      <ActionIcon variant="subtle" onClick={() => abrir(a)}>
                        <IconEdit size={16} />
                      </ActionIcon>
                    </Tooltip>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>

      <ModalArea abierto={abierto} onCerrar={modal.close} inicial={editando} />
    </Stack>
  )
}
